import { useState, useEffect } from "react";
import { SolutionBannerAPI } from "@api";
import "./AdsBadge.scss";

const AdsBadge = function () {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    async function loadData() {
      if (!banner) {
        const bannerData = (await SolutionBannerAPI({type: "top"})).data;        
        setBanner(bannerData.data[0]);
      }
    }

    loadData();
  }, [banner]);

  return (
    <div className="ads-badge">
      <img
        src={
          !banner
            ? "https://dummyimage.com/780x212/ffffff/000000&text=++"
            : banner.image
        }
        width="100%"
        alt=""
      />
    </div>
  );
};

export default AdsBadge;
